<template>
  <div>
    <card>
        <!-- <b-card no-body>
            <b-tabs pills card> -->
                <b-tab title="Tab 2">
                    <b-card-text>
                        <h1>CHECK LIST ANALISI INIZIALE ORGANIZZAZIONE E GESTIONE DELLA SALUTE E SICUREZZA SUL LAVORO</h1>
                        <h2>ORGANIGRAMMA DEL SERVIZIO DI PREVENZIONE E PROTEZIONE</h2>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-6">
                                <label for="datore_lavoro">Datore di lavoro/delegato alla sicurezza<span style="color:#ff0000">*</span></label>
                                <input type="text" class="form-control" v-model="analisi.datore_lavoro">
                            </div>
                            <div class="form-group col-md-2">
                                <label for="delegato_sicurezza">Delegato alla sicurezza<input type="checkbox" class="form-control" v-model="analisi.delegato_sicurezza"></label>
                            </div>
                            <div class="form-group col-md-4" v-if="analisi.delegato_sicurezza">
                                <label for="data_delegato_sicurezza">Indicare la data della delega</label>
                                <input type="date" class="form-control" v-model="analisi.data_delegato_sicurezza">
                            </div>
                        </div>
                        <h3>RSPP</h3>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-6">
                                <label for="rspp_sig">Sig.</label>
                                <input type="text" class="form-control" v-model="analisi.rspp_sig">
                            </div>
                            <div class="form-group col-md-2">
                                <label for="rspp_dl">RSPP DL<input type="checkbox" class="form-control" v-model="analisi.rspp_dl"></label>
                            </div>
                        </div>
                        <h3 style="margin-top:10px">MEDICO COMPETENTE</h3>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-3">
                                <label for="medico_competente_dr">DR</label>
                                <input type="text" class="form-control" v-model="analisi.medico_competente_dr">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="medico_non_nominato">Non nominato</label>
                                <input type="radio" class="form-control" value="medico_non_nominato" v-model="analisi.medico_non_nominato">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="medico_da_nominare">Da nominare</label>
                                <input type="radio" class="form-control" value="medico_da_nominare" v-model="analisi.medico_da_nominare">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="medico_in_fase_nomina">In fase di nomina</label>
                                <input type="radio" class="form-control" value="medico_in_fase_nomina" v-model="analisi.medico_in_fase_nomina">
                            </div>
                        </div>
                        <h3 style="margin-top:10px">RLS o RLST</h3>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-3">
                                <label for="">..</label>
                                <input type="text" class="form-control" >
                            </div>
                            <div class="form-group col-md-3">
                                <label for="rls_non_nominato">Non nominato</label>
                                <input type="radio" class="form-control" value="rls_non_nominato" v-model="analisi.rls_non_nominato">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="rls_da_nominare">Da nominare</label>
                                <input type="radio" class="form-control" value="rls_da_nominare" v-model="analisi.rls_da_nominare">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="rls_in_fase_nomina">In fase di nomina</label>
                                <input type="radio" class="form-control" value="rls_in_fase_nomina" v-model="analisi.rls_in_fase_nomina">
                            </div>
                        </div>
                        <h3 style="margin-top:10px">ADDETO PRIMO SOCCORSO*</h3>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-6">
                                <label for="soccorso_sig1">Sig.</label>
                                <input type="text" class="form-control" value="soccorso_sig1" v-model="analisi.soccorso_sig1">
                            </div>
                             <div class="form-group col-md-6">
                                <label for="soccorso_nomina_del1">Nomina del</label>
                                <input type="date" class="form-control" value="soccorso_nomina_del1" v-model="analisi.soccorso_nomina_del1">
                            </div>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-6">
                                <label for="soccorso_sig2">Sig.</label>
                                <input type="text" class="form-control" value="soccorso_sig2" v-model="analisi.soccorso_sig2">
                            </div>
                             <div class="form-group col-md-6">
                                <label for="soccorso_nomina_del2">Nomina del</label>
                                <input type="date" class="form-control" value="soccorso_nomina_del2" v-model="analisi.soccorso_nomina_del2">
                            </div>
                        </div>
                        <h3 style="margin-top:10px">ADDETO ANTINCENDIO*</h3>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-6">
                                <label for="antincendio_sig1">Sig.</label>
                                <input type="text" class="form-control" value="antincendio_sig1" v-model="analisi.antincendio_sig1">
                            </div>
                             <div class="form-group col-md-6">
                                <label for="antincendio_nomina_del1">Nomina del</label>
                                <input type="date" class="form-control" value="antincendio_nomina_del1" v-model="analisi.antincendio_nomina_del1">
                            </div>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-6">
                                <label for="antincendio_sig2">Sig.</label>
                                <input type="text" class="form-control" value="antincendio_sig2" v-model="analisi.antincendio_sig2">
                            </div>
                             <div class="form-group col-md-6">
                                <label for="antincendio_nomina_del2">Nomina del</label>
                                <input type="date" class="form-control" value="antincendio_nomina_del2" v-model="analisi.antincendio_nomina_del2">
                            </div>
                        </div>
                        <h3 style="margin-top:10px">PREPOSTO</h3>
                        <div class="form-row justify-content-md-center">
                            <div class="form-group col-md-6">
                                <label for="preposto_sig">Sig.</label>
                                <input type="text" class="form-control" value="preposto_sig" v-model="analisi.preposto_sig">
                            </div>
                             <div class="form-group col-md-6">
                                <label for="preposto_nomina_del">Nomina del</label>
                                <input type="date" class="form-control" value="preposto_nomina_del" v-model="analisi.preposto_nomina_del">
                            </div>
                        </div>
                        <div style="text-align:left; margin-top:15px">
                           Legenda
                            <ul>
                                <li>Non nominato: il DL non intende procedere con la procedura di nomina.</li>
                                <li>Da nominare: il DL procederà in seguito con la procedura di nomina.</li>
                                <li>In fase di nomina: il DL ha già iniziato la procedura ma non ha ancora concluso l’iter.</li>
                            </ul>
                        </div>
                    </b-card-text>
                </b-tab>
            <!-- </b-tabs>
        </b-card> -->

        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriIdentificazione()" style="margin-top: 10px;background:#00467f">Salva</button> -->
        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriDati()" style="margin-top: 10px;background:#00467f">Salva</button>
        <router-link :to="'valutazione-a?idCliente='+idCliente"><button class="btn float-right" type="button" style="margin-top: 10px;margin-right:20px;background:#00467f">Avanti</button></router-link>
        <router-link to="/clienti" class="btn float-right" style="margin-top: 10px;margin-right:10px;background:#00467f">Indietro</router-link> -->
        
    </card>
  </div>
</template>
<script>
import Card from "@/components/Cards/Card.vue";
import Services from '@/services/Services';

export default {
    components: {
        Card
    },

    data() {
        return {
            analisi: {},

            // TAB 2
            // datore_lavoro: null,
            // delegato_sicurezza: false,
            // data_delegato_sicurezza: null,
            // rspp_sig: null,
            // rspp_dl: false,
            // medico_competente_dr: null,
            // medico_non_nominato: null,
            // medico_da_nominare: null,
            // medico_in_fase_nomina: null,

            // rls_non_nominato: null,
            // rls_da_nominare: null,
            // rls_in_fase_nomina: null,

            // soccorso_sig1: null,
            // soccorso_nomina_del1: null,
            // soccorso_sig2: null,
            // soccorso_nomina_del2: null,
            // antincendio_sig1: null,
            // antincendio_nomina_del1: null,
            // antincendio_sig2: null,
            // antincendio_nomina_del2: null,
            // preposto_sig: null,
            // preposto_nomina_del: null,
            
            idCliente: null,
            idSoggetto: null,
        }
    },

    props: {
        analisiValori: {
            type: Object,
            required: true
        }
    },
    computed: {},

    methods: {
        addAnalisiValori() {
            this.analisi = Object.assign({}, this.analisiValori);
        },

        // checkData: function() {
            // if () {
            //     alert("Compilare tutti i dati!");
            //     return false;
            // } else {
            //     return true;
            // }
        // },


        // salvaValoriDati: async function() {
        //     let errore = 0;
        //     let dati = [];
        //     dati.push({ 
        //        });
        //     let datiJSON=JSON.stringify(dati[0]);
        //     let salvaValori = [];
            // await AntiriciclaggioServices.updateSoggetto(datiJSON, this.idCliente, this.idSoggetto) 
            // .then(response => { salvaValori= response.data})
            // .catch( function (error) {
            //     if(error.response.status == 401){
            //     errore = error.response.status;
            //     }
            // });
            // if (errore == 401) {
            //     let value = await Services.refreshTokenFunction();
            //     if (value) { await this.salvaValoriDati(); }
            // }
        // },

        // main: async function() {
        //     this.idCliente = this.$route.query.idCliente;
            
        // },
    },
    created() {
        this.addAnalisiValori();
    },
    
    // mounted() {
    //     this.main();
    // } 

};
</script>
<style scoped>
    .row-color:hover {
    background-color: #00467f53;
    }
    label {
        font-size: 16px;
    }

    .label-switch {
            position: relative;
        /* display: inline-block; */
        display: table-cell;
        padding-right: 10px;
        padding-left: 10px;
        font-size: 16px;
    }
    .switch {
        position: relative;
        /* display: inline-block; */
        display: table-cell;
        width: 55px;
        height: 34px;
    }

    .switch input { 
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

        .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 0px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }
    input:checked + .slider {
        background-color: #00467f;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #00467f;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }
    .slider.round:before {
        border-radius: 50%;
    }
</style>
